import each from 'lodash/each';
import get from 'lodash/get';
import set from 'lodash/set';
import merge from 'lodash/merge';
import isFunction from 'lodash/isFunction';
import has from 'lodash/has';
import isArray from 'lodash/isArray';
import isObjectLike from 'lodash/isObjectLike';
import remove from 'lodash/remove';

export default {
  each,
  get,
  merge,
  set,
  isFunction,
  has,
  isArray,
  isObjectLike,
  remove,
};
